<div class="contact-tabs">
  <div class="information-header-container">
    <app-back-button [title]="'module.contact.moduleName' | translate" (backClicked)="gotoDashboard()"> </app-back-button>
    <button class="btn btn-outline-primary video-btn" (click)="addVideo()" *ngIf="tabIndex === 1 && !!authService.permissions.VIDEO_UPDATE">
      <span class="fa fa-plus"></span>{{ 'module.information.buttonText' | translate }}
    </button>
  </div>

  <mat-tab-group [(selectedIndex)]="tabIndex" [animationDuration]="0" [disableRipple]="true">
    <mat-tab>
      <ng-template mat-tab-label>
        <div>
          <span class="tab-text">{{ 'module.information.videoTabText2' | translate }}</span>
        </div>
      </ng-template>

      <ng-template matTabContent>
        <div class="tab-content">
          <app-contact-page #contactPageComponent></app-contact-page>
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab *ngIf="!!authService.permissions.VIDEO_PAGE">
      <ng-template mat-tab-label>
        <div>
          <span class="tab-text">{{ 'module.information.videoTabText' | translate }}</span>
        </div>
      </ng-template>
      <ng-template matTabContent>
        <div class="tab-content">
          <app-videos #videosComponent></app-videos>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
